import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import layersReducer from './slices/layersSlice';
import mapReducer from './slices/mapSlice';
import uiReducer from './slices/uiSlice';
import selectionReducer from './slices/selectionSlice';
import attributeHistoryReducer from './slices/attributeHistorySlice';
import geometryEditingReducer from './slices/geometryEditingSlice';
import mergeToolReducer from './slices/mergeToolSlice';
import measurementReducer from './slices/measurementSlice';
import spatialAnalysisReducer from './slices/spatialAnalysisSlice';
import bookmarksReducer from './slices/bookmarksSlice';
import printExportReducer from './slices/printExportSlice';
import geocodingReducer from './slices/geocodingSlice';
import drawingReducer from './slices/drawingSlice';
import coordinateSystemReducer from './slices/coordinateSystemSlice';
import digitizationReducer from './slices/digitizationSlice';
import geometryProcessingReducer from './slices/geometryProcessingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    layers: layersReducer,
    map: mapReducer,
    ui: uiReducer,
    selection: selectionReducer,
    attributeHistory: attributeHistoryReducer,
    geometryEditing: geometryEditingReducer,
    mergeTool: mergeToolReducer,
    measurement: measurementReducer,
    spatialAnalysis: spatialAnalysisReducer,
    bookmarks: bookmarksReducer,
    printExport: printExportReducer,
    geocoding: geocodingReducer,
    drawing: drawingReducer,
    coordinateSystem: coordinateSystemReducer,
    digitization: digitizationReducer,
    geometryProcessing: geometryProcessingReducer,
  },
  devTools: import.meta.env.MODE !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
